import React from 'react';
import { Field, FieldProps } from 'formik';
import { Toggle, ToggleFlag } from '../form-controls';
import clsx from 'clsx';

interface ToggleProps {
  label: string;
  name: string;
  disabled?: boolean;
  wrapperClasses?: string;
}

type FlagType = 'Y' | 'N';

export const FormikToggle = ({
  label,
  wrapperClasses = 'flex items-center justify-between',
  ...props
}: ToggleProps) => {
  return (
    <div className={wrapperClasses}>
      {label && (
        <label
          className={clsx(
            'block mb-2 text-base tracking-wide font-effra',
            props.disabled ? 'text-gray-20' : 'text-black-default'
          )}
          htmlFor={`Toggle-${props.name}`}
        >
          {label}
        </label>
      )}
      <Field name={props.name}>
        {({ field, form }: FieldProps) => {
          const changeHandler = (checked: boolean) => {
            form.setFieldValue(props.name, checked);
          };
          return <Toggle {...field} {...props} onChange={changeHandler} />;
        }}
      </Field>
    </div>
  );
};

export const FormikToggleFlag = ({ label, wrapperClasses = 'flex gap-2 items-center', ...props }: ToggleProps) => {
  return (
    <div className={wrapperClasses}>
      <Field name={props.name}>
        {({ field, form }: FieldProps) => {
          const changeHandler = (checked: FlagType) => {
            form.setFieldValue(props.name, checked);
          };
          return <ToggleFlag {...field} {...props} onChange={changeHandler} />;
        }}
      </Field>
      {label && (
        <label
          className={clsx(
            'block text-base tracking-wide font-effra',
            props.disabled ? 'text-gray-20' : 'text-black-default'
          )}
          htmlFor={`Toggle-${props.name}`}
        >
          {label}
        </label>
      )}
    </div>
  );
};
